import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { destinations, tours, activities } from '../data';
import { TourCard } from '../components/ui/Cards';
import { ActivityCard } from '../components/ui/Cards';
import './DetailPage.css';

export default function DestinationDetail() {
  const { slug } = useParams();
  const dest = destinations.find(d => d.slug === slug);

  if (!dest) return (
    <div className="not-found-msg container">
      Destination not found. <Link to="/destinations">Back to destinations</Link>
    </div>
  );

  const relatedTours = tours.filter(t => t.destination === dest.slug);
  const relatedActivities = activities.filter(a => a.location.toLowerCase().includes(dest.name.toLowerCase()) || dest.slug === 'marrakech');

  return (
    <>
      <div style={{ position: 'relative', marginTop: 72, height: 420, overflow: 'hidden', background: dest.bgColor }}>
        {dest.image && (
          <img
            src={dest.image}
            alt={dest.name}
            style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center', display: 'block' }}
          />
        )}
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom, rgba(0,0,0,0.25), rgba(0,0,0,0.55))' }} />
      </div>

      <div className="container" style={{ paddingTop: 40, paddingBottom: 80 }}>
        <div className="breadcrumb">
          <Link to="/">Home</Link> <span>/</span>
          <Link to="/destinations">Destinations</Link> <span>/</span>
          <span>{dest.name}</span>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 300px', gap: 48, alignItems: 'start' }}>
          <div>
            <span className="badge badge-gold">{dest.region}</span>
            <h1 className="detail-title">{dest.name}</h1>
            <p style={{ fontSize: 18, color: 'var(--muted)', fontStyle: 'italic', marginBottom: 20 }}>{dest.tagline}</p>
            <p className="detail-desc">{dest.description}</p>

            <h3 className="detail-sub-title">Top Highlights</h3>
            <ul className="highlight-list">
              {dest.highlights.map((h, i) => <li key={i}><span className="highlight-dot" />{h}</li>)}
            </ul>
          </div>

          <div className="booking-card" style={{ position: 'sticky', top: 88 }}>
            <h3 style={{ fontFamily: 'var(--font-display)', fontSize: 18, marginBottom: 16 }}>Quick Facts</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              {dest.region && <div className="quick-fact"><span className="quick-fact__label">Region</span><span className="quick-fact__val">{dest.region}</span></div>}
              {dest.distanceFromMarrakech !== '—' && <div className="quick-fact"><span className="quick-fact__label">From Marrakech</span><span className="quick-fact__val">{dest.distanceFromMarrakech}</span></div>}
              <div className="quick-fact"><span className="quick-fact__label">Best time to visit</span><span className="quick-fact__val">{dest.bestTime}</span></div>
              <div className="quick-fact"><span className="quick-fact__label">Climate</span><span className="quick-fact__val">{dest.climate}</span></div>
              {dest.tourCount > 0 && <div className="quick-fact"><span className="quick-fact__label">Tours available</span><span className="quick-fact__val">{dest.tourCount}</span></div>}
              {dest.activityCount > 0 && <div className="quick-fact"><span className="quick-fact__label">Activities</span><span className="quick-fact__val">{dest.activityCount}</span></div>}
            </div>
            <Link to="/book" className="btn btn-primary" style={{ display: 'block', textAlign: 'center', marginTop: 20 }}>
              Book a Tour Here
            </Link>
          </div>
        </div>

        {relatedTours.length > 0 && (
          <div style={{ marginTop: 60 }}>
            <h2 className="section-title" style={{ marginBottom: 28 }}>Tours to {dest.name}</h2>
            <div className="grid-3">
              {relatedTours.map(t => <TourCard key={t.id} tour={t} />)}
            </div>
          </div>
        )}

        {relatedActivities.length > 0 && dest.activityCount > 0 && (
          <div style={{ marginTop: 60 }}>
            <h2 className="section-title" style={{ marginBottom: 28 }}>Activities in {dest.name}</h2>
            <div className="grid-4">
              {relatedActivities.slice(0, 4).map(a => <ActivityCard key={a.id} activity={a} />)}
            </div>
          </div>
        )}
      </div>
    </>
  );
}
